(function () {
	console.log("VisualACE: website_script.js loaded at", new Date().toISOString());
	var LOGO_URL = "/assets/bullion_flow_erp/images/logo.png";
	var FAV_URL = "/assets/bullion_flow_erp/images/advisorygold-favicon.png";

	// Version constant for cache busting - update this when logo changes
	// This enables browser caching while still allowing updates when needed
	var ASSET_VERSION = "1.0.0";

	// Preload logo image immediately to prevent flash
	var logoPreload = new Image();
	logoPreload.onload = function () {
		console.log("VisualACE: Logo preloaded successfully:", this.src);
	};
	logoPreload.onerror = function () {
		console.warn("VisualACE: Logo preload failed:", this.src);
	};
	logoPreload.src = LOGO_URL + "?v=" + ASSET_VERSION;
	console.log("VisualACE: Preloading logo image:", logoPreload.src);

	// Add preload link in head for faster loading
	if (document.head) {
		var preloadLink = document.createElement("link");
		preloadLink.rel = "preload";
		preloadLink.as = "image";
		preloadLink.href = LOGO_URL + "?v=" + ASSET_VERSION;
		document.head.appendChild(preloadLink);
		console.log("VisualACE: Added preload link for logo");
	}

	function onceReady(fn) {
		if (document.readyState === "complete" || document.readyState === "interactive") {
			setTimeout(fn, 0);
		} else {
			document.addEventListener("DOMContentLoaded", fn, { once: true });
		}
	}

	function setLogoOnce() {
		var img = document.querySelector(
			'.page-card-head img, img.app-logo, .login-content img, .page-card img, .page-card-head img, img[src*="advisorygold"], img[src*="AdvisoryGold"], img[src*="logo"], img[src*="frappe"], img[src*="erpnext"]'
		);
		if (!img) {
			console.log("VisualACE: No logo image found yet, will retry...");
			return; // login not rendered yet (webdesk, etc.)
		}
		var src = img.getAttribute("src") || "";
		console.log("VisualACE: Found logo image:", img.tagName, "Current src:", src);
		console.log("VisualACE: Current URL:", window.location.href);
		console.log("VisualACE: Current pathname:", window.location.pathname);

		// Check if we're on login page - more comprehensive detection
		var isLoginPage =
			window.location.pathname === "/login" ||
			window.location.pathname.startsWith("/login") ||
			window.location.hash.includes("login") ||
			document.querySelector(".login-content") ||
			document.querySelector(".page-card.login-card") ||
			document.querySelector(".login-form") ||
			document.querySelector(".login-wrapper");

		console.log("VisualACE: Is login page?", isLoginPage);

		if (isLoginPage) {
			// Login page: use logo.png and apply large styling
			console.log("VisualACE: Login page detected - setting logo.png");

			// Try logo.png first, then fallback to bullionflow-logo.png
			var logoPath = "/assets/bullion_flow_erp/images/logo.png";
			var cacheBuster = "?v=" + ASSET_VERSION;

			// Hide default logo immediately
			if (src.includes("frappe") || src.includes("erpnext")) {
				img.style.cssText =
					"opacity: 0 !important; visibility: hidden !important; display: none !important;";
			}

			// Remove any existing error handlers
			img.onerror = null;
			img.onload = function () {
				console.log("VisualACE: Logo loaded successfully:", this.src);
				// Show and apply styles after image loads
				this.style.cssText =
					"opacity: 1 !important; visibility: visible !important; display: block !important; max-height: 350px !important; height: 320px !important; width: auto !important; object-fit: contain !important; margin-bottom: -25px !important; margin-left: auto !important; margin-right: auto !important; filter: none !important; background: transparent !important; background-color: transparent !important; mix-blend-mode: normal !important; -webkit-filter: none !important;";
			};

			// Set the source with cache buster
			img.src = logoPath + cacheBuster;
			img.setAttribute("src", logoPath + cacheBuster);

			// Apply styles immediately (but keep hidden until loaded)
			img.style.cssText =
				"opacity: 0 !important; visibility: hidden !important; max-height: 350px !important; height: 320px !important; width: auto !important; object-fit: contain !important; margin-bottom: -25px !important; display: block !important; margin-left: auto !important; margin-right: auto !important; filter: none !important; background: transparent !important; background-color: transparent !important; mix-blend-mode: normal !important; -webkit-filter: none !important;";

			// Ensure logo container is centered - NUCLEAR APPROACH
			var logoContainer = img.closest(".page-card-head");
			if (logoContainer) {
				// Apply all centering styles with !important via setProperty
				logoContainer.style.setProperty("text-align", "center", "important");
				logoContainer.style.setProperty("display", "flex", "important");
				logoContainer.style.setProperty("flex-direction", "column", "important");
				logoContainer.style.setProperty("align-items", "center", "important");
				logoContainer.style.setProperty("justify-content", "center", "important");
				logoContainer.style.setProperty("width", "100%", "important");
				logoContainer.style.setProperty("max-width", "100%", "important");
				logoContainer.style.setProperty("margin", "0 auto", "important");
				logoContainer.style.setProperty(
					"padding",
					"max(5vh, 30px) 0 14px 0px",
					"important"
				);
				logoContainer.style.setProperty("position", "relative", "important");
				logoContainer.style.setProperty("left", "auto", "important");
				logoContainer.style.setProperty("right", "auto", "important");
				logoContainer.style.setProperty("float", "none", "important");
				logoContainer.style.setProperty("grid-column", "1 / -1", "important");
				logoContainer.style.setProperty("align-self", "center", "important");
				console.log("VisualACE: Applied centering styles to logo container");
			}

			// Also center the parent container - NUCLEAR
			var loginSection = document.querySelector(".for-login");
			if (loginSection) {
				loginSection.style.setProperty("display", "flex", "important");
				loginSection.style.setProperty("flex-direction", "column", "important");
				loginSection.style.setProperty("align-items", "center", "important");
				loginSection.style.setProperty("justify-content", "flex-start", "important");
				loginSection.style.setProperty("width", "100%", "important");
				loginSection.style.setProperty("text-align", "center", "important");
				loginSection.style.setProperty("position", "relative", "important");
				console.log("VisualACE: Applied centering styles to login section");
			}

			// Center all children of login section
			var loginChildren = document.querySelectorAll(".for-login > *");
			loginChildren.forEach(function (child) {
				child.style.setProperty("margin-left", "auto", "important");
				child.style.setProperty("margin-right", "auto", "important");
				child.style.setProperty("text-align", "center", "important");
				if (child.classList.contains("page-card-head")) {
					child.style.setProperty("align-self", "center", "important");
					child.style.setProperty("width", "100%", "important");
				}
			});

			// Force logo to load with error handling
			img.onerror = function () {
				console.warn("VisualACE: logo.png failed to load, trying bullionflow-logo.png");
				this.src = "/assets/bullion_flow_erp/images/bullionflow-logo.png" + cacheBuster;
				this.onerror = function () {
					console.warn(
						"VisualACE: bullionflow-logo.png failed, trying advisorygold-logo.png"
					);
					this.src =
						"/assets/bullion_flow_erp/images/advisorygold-logo.png" + cacheBuster;
					this.onerror = function () {
						console.error("VisualACE: All logo files failed to load!");
					};
				};
			};
		} else {
			// Dashboard/other pages: use advisorygold-logo.png
			console.log("VisualACE: Dashboard page detected - using advisorygold-logo.png");
			img.setAttribute(
				"src",
				"/assets/bullion_flow_erp/images/advisorygold-logo.png" + "?v=" + ASSET_VERSION
			);
			// Reset to default styling for dashboard
			img.style.maxHeight = "";
			img.style.height = "";
			img.style.width = "";
			img.style.objectFit = "";
			img.style.marginBottom = "";
		}
	}

	function changeLoginText() {
		// Change "Login to Frappe" to "Login to BullionFlow"
		// The title is in an h4 inside .page-card-head
		var titleElements = document.querySelectorAll(
			".page-card-head h4, .page-card-head h1, .page-card-title, h1.page-card-title, .page-card h1, .page-card h4"
		);
		titleElements.forEach(function (el) {
			if (
				el &&
				(el.textContent.includes("Login to Frappe") ||
					el.textContent.includes("Frappe") ||
					el.textContent.includes("Login"))
			) {
				el.textContent = "Login to BullionFlow";
				console.log('VisualACE: Changed login title to "Login to BullionFlow"', el);
			}
		});

		// Also try to find and replace any text containing "Login to Frappe" using TreeWalker
		try {
			var walker = document.createTreeWalker(
				document.body,
				NodeFilter.SHOW_TEXT,
				null,
				false
			);

			var node;
			while ((node = walker.nextNode())) {
				if (node.textContent && node.textContent.includes("Login to Frappe")) {
					node.textContent = node.textContent.replace(
						/Login to Frappe/g,
						"Login to BullionFlow"
					);
					console.log("VisualACE: Replaced text node via TreeWalker");
				}
			}
		} catch (e) {
			console.warn("VisualACE: TreeWalker error", e);
		}
	}

	function hideEmailLinkButton() {
		// Hide "Login with Email Link" button and "or" divider - MORE AGGRESSIVE
		var allButtons = document.querySelectorAll("button, .btn, a.btn");
		allButtons.forEach(function (btn) {
			var text = (btn.textContent || "").toLowerCase();
			if (text.includes("email link") || text.includes("login with email")) {
				btn.style.cssText =
					"display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; width: 0 !important; padding: 0 !important; margin: 0 !important;";
				btn.setAttribute("hidden", "true");
				console.log("VisualACE: Hid email link button:", btn);
			}
		});

		// Hide "or" divider text - check all text elements
		var allElements = document.querySelectorAll("*");
		allElements.forEach(function (el) {
			var text = (el.textContent || "").trim();
			// Check if element only contains "or" (with possible whitespace)
			if (
				text === "or" ||
				text === "or" ||
				(text.length <= 5 && text.toLowerCase().includes("or"))
			) {
				var parent = el.parentElement;
				// Make sure it's not hiding important content
				if (
					parent &&
					(parent.classList.contains("page-card-body") ||
						parent.classList.contains("page-card-actions") ||
						parent.classList.contains("text-muted"))
				) {
					el.style.cssText =
						"display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; width: 0 !important; padding: 0 !important; margin: 0 !important;";
					el.setAttribute("hidden", "true");
					console.log('VisualACE: Hid "or" divider:', el);
				}
			}
		});

		// Hide social login sections and email link sections
		var socialSections = document.querySelectorAll(
			".social-login-buttons, .login-with-email-link, .login-with-email-link-wrapper"
		);
		socialSections.forEach(function (section) {
			section.style.cssText = "display: none !important; visibility: hidden !important;";
			section.setAttribute("hidden", "true");
		});
	}

	function setFaviconOnce() {
		var head = document.head;
		if (!head) return;
		var link = head.querySelector('link[rel~="icon"], link[rel="shortcut icon"]');
		if (!link) {
			link = document.createElement("link");
			link.rel = "icon";
			link.type = "image/png";
			head.appendChild(link);
		}
		if (link.href.indexOf("advisorygold-favicon.png") === -1) {
			link.href = FAV_URL;
		}
	}

	function handleSplashScreen() {
		console.log("VisualACE: Looking for splash image...");

		// Check ALL images on the page
		var allImages = document.querySelectorAll("img");
		console.log("VisualACE: All images on page:", allImages.length);

		var splashFound = false;
		allImages.forEach(function (img, index) {
			console.log("VisualACE: Image " + index + ":", img.src, img.alt);

			// Check if this image contains "splash" in src or alt
			if (
				img.src &&
				(img.src.includes("splash") ||
					(img.alt && img.alt.toLowerCase().includes("splash")))
			) {
				console.log("VisualACE: Found splash image! Making it full screen:", img.src);
				splashFound = true;

				// Force full screen styling
				img.style.cssText = `
                    width: 100vw !important;
                    height: 100vh !important;
                    max-width: 100vw !important;
                    max-height: 100vh !important;
                    object-fit: cover !important;
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    z-index: 9999 !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    border: none !important;
                    border-radius: 0 !important;
                    background: #000 !important;
                `;

				// Hide splash after 3 seconds
				setTimeout(function () {
					img.style.display = "none";
					console.log("VisualACE: Splash screen hidden after 3 seconds");
				}, 3000);
			}
		});

		if (!splashFound) {
			console.log("VisualACE: No splash image found in any images");
		}
	}

	function addPWAManifest() {
		var head = document.head;
		if (!head) {
			console.log("VisualACE: head element not found");
			return;
		}

		// Add manifest link
		if (!head.querySelector('link[rel="manifest"]')) {
			var manifestLink = document.createElement("link");
			manifestLink.rel = "manifest";
			manifestLink.href = "/assets/bullion_flow_erp/manifest.json";
			head.appendChild(manifestLink);
			console.log("VisualACE: PWA manifest link added");
		}

		// Add theme color
		if (!head.querySelector('meta[name="theme-color"]')) {
			var themeColor = document.createElement("meta");
			themeColor.name = "theme-color";
			themeColor.content = "#2490ef";
			head.appendChild(themeColor);
			console.log("VisualACE: PWA theme color added");
		}

		// Add apple-specific meta tags for iOS PWA support
		if (!head.querySelector('meta[name="apple-mobile-web-app-capable"]')) {
			var appleCapable = document.createElement("meta");
			appleCapable.name = "apple-mobile-web-app-capable";
			appleCapable.content = "yes";
			head.appendChild(appleCapable);
		}

		if (!head.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')) {
			var appleStatus = document.createElement("meta");
			appleStatus.name = "apple-mobile-web-app-status-bar-style";
			appleStatus.content = "default";
			head.appendChild(appleStatus);
		}

		if (!head.querySelector('link[rel="apple-touch-icon"]')) {
			var appleTouchIcon = document.createElement("link");
			appleTouchIcon.rel = "apple-touch-icon";
			appleTouchIcon.href = "/assets/bullion_flow_erp/images/pwa-icon-192.png";
			head.appendChild(appleTouchIcon);
		}

		// Register Service Worker for PWA
		if ("serviceWorker" in navigator) {
			navigator.serviceWorker
				.register("/assets/bullion_flow_erp/service-worker.js")
				.then(function (registration) {
					console.log(
						"VisualACE: Service Worker registered successfully:",
						registration.scope
					);
				})
				.catch(function (error) {
					console.log("VisualACE: Service Worker registration failed:", error);
				});
		}

		// Handle PWA install prompt
		let deferredPrompt;
		window.addEventListener("beforeinstallprompt", function (e) {
			// Prevent the mini-infobar from appearing on mobile
			e.preventDefault();
			// Stash the event so it can be triggered later
			deferredPrompt = e;
			console.log("VisualACE: PWA install prompt available");

			// Show custom install button if not already shown
			showInstallButton();
		});

		// Function to show install button
		function showInstallButton() {
			// Check if button already exists
			if (document.getElementById("pwa-install-button")) {
				return;
			}

			// Check if app is already installed
			if (window.matchMedia("(display-mode: standalone)").matches) {
				console.log("VisualACE: App is already installed");
				return;
			}

			// Create install button
			var installButton = document.createElement("button");
			installButton.id = "pwa-install-button";
			installButton.innerHTML = "📱 Install App";
			installButton.style.cssText = `
                       position: fixed;
                       bottom: 20px;
                       right: 20px;
                       background-color: #D4AF37;
                       color: #000;
                       border: none;
                       padding: 12px 24px;
                       border-radius: 8px;
                       font-size: 14px;
                       font-weight: bold;
                       cursor: pointer;
                       box-shadow: 0 4px 12px rgba(0,0,0,0.3);
                       z-index: 10000;
                       display: flex;
                       align-items: center;
                       gap: 8px;
                   `;

			installButton.addEventListener("click", function () {
				if (deferredPrompt) {
					// Show the install prompt
					deferredPrompt.prompt();

					// Wait for the user to respond to the prompt
					deferredPrompt.userChoice.then(function (choiceResult) {
						if (choiceResult.outcome === "accepted") {
							console.log("VisualACE: User accepted the install prompt");
						} else {
							console.log("VisualACE: User dismissed the install prompt");
						}
						deferredPrompt = null;
						installButton.remove();
					});
				} else {
					// Fallback: try to open install dialog
					if (window.navigator.standalone === false) {
						alert(
							'To install this app, please use your browser\'s menu and select "Add to Home Screen"'
						);
					}
				}
			});

			document.body.appendChild(installButton);
		}

		// Check if app is installable after a delay
		setTimeout(function () {
			if (deferredPrompt) {
				showInstallButton();
			}
		}, 2000);

		console.log("VisualACE: PWA manifest configured for login page");
	}

	// Redirect to /app if logged in and visiting the root URL
	if (window.location.pathname === "/" || window.location.pathname === "/index") {
		// Small delay to ensure frappe object is available
		setTimeout(function () {
			if (
				window.frappe &&
				frappe.session &&
				frappe.session.user &&
				frappe.session.user !== "Guest"
			) {
				console.log("VisualACE: Logged in user on root - redirecting to /app");
				window.location.href = "/app";
			}
		}, 100);
	}

	// Run immediately without waiting for DOMContentLoaded to prevent flash
	setLogoOnce();
	setFaviconOnce();

	// Also run on DOMContentLoaded for safety
	onceReady(function () {
		setLogoOnce();
		setFaviconOnce();
		changeLoginText();
		hideEmailLinkButton();
		handleSplashScreen();
		addPWAManifest(); // Add PWA support to login page

		// Use MutationObserver to catch logo and other DOM changes
		if (typeof MutationObserver !== "undefined") {
			const observer = new MutationObserver(function (mutations, obs) {
				// Check if logo element is present or if login elements are added
				var logoImg = document.querySelector(
					".page-card-head img, img.app-logo, .login-content img"
				);
				var loginContent = document.querySelector(".login-content, .page-card.login-card");

				if (logoImg || loginContent) {
					setLogoOnce();
					setFaviconOnce();
					changeLoginText();
					hideEmailLinkButton();
					handleSplashScreen();
					// Disconnect after successful execution to avoid unnecessary overhead
					obs.disconnect();
				}
			});

			// Observe document body for changes
			if (document.body) {
				observer.observe(document.body, {
					childList: true,
					subtree: true,
					attributes: true,
					attributeFilter: ["src"],
				});
			}
		}

		// Fallback: try a couple of strategic times in case MutationObserver misses
		setTimeout(function () {
			setLogoOnce();
			changeLoginText();
			hideEmailLinkButton();
			handleSplashScreen();
		}, 100);

		setTimeout(function () {
			setLogoOnce();
			changeLoginText();
			hideEmailLinkButton();
		}, 500);
	});
})();
